import styled from "styled-components";

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const FormBody = styled.div`
  max-height: 65vh;
  overflow-y: auto;
  position: relative;
  opacity: ${(props) => (props.$isLoading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$isLoading ? "none" : "auto")};
  transition: opacity 0.2s ease;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.375rem;
  border-top: 1px solid #ececec;
`;

export const ButtonWrapperFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.375rem;
  border-top: 1px solid #ececec;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 15px;
`;

export const SectionTitle = styled.h3`
  font-family: Lato;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0a4986;
  margin: 0 0 10px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #d9d9d9;
`;

export const ContainerLabel = styled.label`
  display: block;
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 0.9375rem;
  line-height: 1;
  color: #1bace4;
  margin-bottom: 6px;

  &::after {
    content: ${(props) => (props?.required ? '"*"' : '""')};
    color: #ea6457;
    font-weight: bold;
    margin-left: 3px;
  }
`;

export const CommentLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #1bace4;
  font-family: Lato;
  font-size: 0.9375rem;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  margin: 5px 0 20px 0;
`;

export const ItemSelectorBox = styled.div`
  border: 1.5px solid #1bace4;
  border-radius: 6px;
  padding: 15px 18px;
  margin-bottom: 20px;
`;

export const ItemSelectorLabel = styled.p`
  font-family: Lato;
  font-size: 0.9375rem;
  font-weight: 700;
  color: #1bace4;
  margin: 0 0 12px 0;
`;

export const ItemSelectorRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr 1fr 1fr auto auto"};
  gap: 15px;
  align-items: end;
`;

export const ReadonlyField = styled.div`
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f5f5f5;
  color: #474747;
  font-family: Lato;
  font-size: 0.875rem;
`;

export const AddCircleButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #1bace4;
  border: none;
  color: white;
  font-size: 1.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #1589b6;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const FreeLineLink = styled.a`
  color: #767676;
  font-family: Lato;
  font-size: 0.8125rem;
  font-style: italic;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
`;

export const AddLineButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const GenericErrorBanner = styled.div`
  background: #fdecea;
  border: 1px solid #ea6457;
  color: #a83226;
  padding: 10px 15px;
  border-radius: 4px;
  font-family: Lato;
  font-size: 0.875rem;
  margin-bottom: 15px;
`;

export const LineItemsTableWrapper = styled.div`
  margin-top: 10px;
`;

export const GroupHeaderBar = styled.div`
  background-color: ${(props) =>
    props.isFree ? "rgba(240, 128, 70, 0.2)" : "#00839533"};
  color: #0A4986;
  padding: 8px 12px;
  font-family: Lato;
  font-size: 0.9375rem;
  font-weight: 700;
`;

export const LineItemsGrid = styled.div`
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
`;

export const LineItemsHeaderRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  line-height: 35px;
  align-items: center;
  background: #008395;
  opacity: 1;
  transform: rotate(0deg);
`;

export const LineItemsHeaderCell = styled.div`
  padding: 0 8px;
  font-family: Lato;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #fff;
`;

export const LineItemsRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  align-items: start;
  padding: 6px 0;
  border-bottom: 1px solid #e0e0e0;
`;

export const LineItemsCell = styled.div`
  padding: 6px 8px;
`;

export const LineItemsRowCommentCell = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  padding: 0 0 6px 0;
  border-bottom: 1px solid #e0e0e0;

  > * {
    grid-column: 2 / -1;
    padding: 0 8px;
  }
`;

export const HesusServiceLabel = styled.div`
  font-family: Lato;
  font-size: 0.875rem;
  font-weight: 700;
  color: #333;
`;

export const HesusServiceSubLabel = styled.div`
  font-family: Lato;
  font-size: 0.8125rem;
  font-style: italic;
  color: #767676;
`;

export const LineItemInput = styled.input`
  width: 100%;
  padding: 6px 8px;
  border: 1px solid ${(props) => (props.$hasError ? "red" : "#ccc")};
  border-radius: 4px;
  font-family: Lato;
  font-size: 0.875rem;

  &:focus {
    outline: none;
    border-color: #1bace4;
  }

  &:read-only {
    background: #f5f5f5;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  appearance: textfield;
`;

export const LineItemSelect = styled.select`
  width: 100%;
  padding: 6px 8px;
  border: 1px solid ${(props) => (props.$hasError ? "red" : "#ccc")};
  border-radius: 4px;
  font-family: Lato;
  font-size: 0.875rem;
  background: white;

  &:focus {
    outline: none;
    border-color: #1bace4;
  }
`;

export const RemoveButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ea6457;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease;

  &:hover {
    background: #c94b40;
  }

  img {
    filter: brightness(0) invert(1);
    width: 14px;
    height: 14px;
  }
`;

export const RowCommentLink = styled.a`
  display: inline-block;
  color: #1bace4;
  font-family: Lato;
  font-size: 0.8125rem;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 4px;
`;

export const RowCommentEditorWrapper = styled.div`
  padding: 8px 0 4px 0;
`;

export const NoLineItemsMessage = styled.p`
  color: #767676;
  font-family: Lato;
  font-size: 0.875rem;
  font-style: italic;
  margin: 10px 0;
`;

export const ErrorText = styled.span`
  color: red;
  font-size: 0.8125rem;
  font-family: Lato;
`;

export const ApiErrorText = styled.div`
  color: red;
  font-family: Lato;
  font-size: 0.875rem;
  margin-right: 15px;
`;

